<template>
  <div class="fts-form-footer">
    <div class="form-footer__l" v-if="continuableCreateRight">
      <fts-checkbox v-model="isContinuableCreate">
        create more <fts-release-badge alpha class="fts-align-top" />
      </fts-checkbox>
    </div>

    <div class="form-footer__r">
      <fts-btn 
        text 
        :disabled="submitting" 
        class="form-btn-standard" 
        @click.native.prevent="$emit('cancel')" 
        v-if="!disableCancel"
      >
        <font-awesome-icon :icon="['fas', 'times']" />Cancel
      </fts-btn>

      <div class="form-activity-continue" v-if="isInternal && enableContinuableActivity && activity.id != 'create'">
        <fts-checkbox v-model="mutableIsActivityContinuable" :disabled="submitting">
          <span class="fts-whitespace-nowrap">Continue with <fts-release-badge alpha class="fts-align-top" /></span>
        </fts-checkbox>
      </div>

      <fts-btn
        color="danger"
        :disabled="loading"
        :loading="submitting"
        class="form-btn-standard"
        @click.native.prevent="$emit('submit')"
        v-if="activity && activity.id == 'delete'"
      >
        <i :class="activity.icon" v-if="activity.icon"></i>{{ activity.name }}
      </fts-btn>

      <fts-btn
        color="primary"
        :disabled="loading"
        :loading="submitting"
        class="form-btn-standard"
        @click.native.prevent="$emit('submit')"
        v-else-if="activity && ['assign', 'changeStatus', 'duplicate'].indexOf(activity.id) > -1"
      >
        <i :class="activity.icon" v-if="activity.icon"></i>{{ activity.name }}
      </fts-btn>

      <fts-btn
        outline
        text-transform-init
        color="secondary"
        :disabled="loading"
        :loading="submitting"
        class="form-btn-standard btn-activity"
        @click.native.prevent="$emit('sync:submit')"
        v-else-if="enableActivityInfo && activity && activity.id == 'manage'"
      >
        <i :class="activity.icon" v-if="activity.icon"></i>{{ activity.name }}
      </fts-btn>

      <fts-btn
        color="danger"
        outline
        :loading="syncState == 'syncing'"
        class="form-btn-standard"
        @click.native.prevent="$emit('synchronize', {})"
        v-else-if="syncState == 'resync'"
      >
        <font-awesome-icon :icon="['fas', 'sync-alt']" />Resync
      </fts-btn>

      <fts-btn 
        text-transform-init 
        box-shadow-none 
        color="primary" 
        :disabled="loading" 
        :loading="submitting" 
        class="btn-activity"
        @click.native.prevent="$emit('sync:submit')" 
        v-else-if="isLite"
      >
        {{activity.name}}
      </fts-btn>

      <fts-btn
        outline
        text-transform-init
        :emoji="activity.emoji"
        :color="activity.color || 'primary'"
        :disabled="loading"
        :loading="submitting"
        class="btn-activity"
        @click.native.prevent="$emit('sync:submit')"
        v-else-if="enableActivityInfo"
      >
        <template v-if="activity.id == 'create'">
          <span class="btn-activity-label">Create</span>
        </template>

        <template v-else>
          <i :class="activity.icon" v-if="activity.icon"></i>
          <span class="btn-activity-label">{{activity.name}}</span>
        </template>
      </fts-btn>

      <fts-btn
        color="primary"
        :disabled="loading"
        :loading="submitting"
        class="form-btn-standard"
        @click.native.prevent="$emit('sync:submit')"
        v-else
      >
        <font-awesome-icon :icon="['fas', 'check']" />Ok
      </fts-btn>
    </div>
  </div>
</template>

<script>
import { authorizationStore } from '../../store/authorizationStore';

import FTSBtn from '../FTSBtn';
import FTSCheckbox from '../FTSCheckbox';
import FTSReleaseBadge from '../FTSReleaseBadge';

export default {
  components: {
    "fts-btn": FTSBtn,
    "fts-checkbox": FTSCheckbox,
    "fts-release-badge": FTSReleaseBadge
  },
  data: () => ({
    isContinuableCreate: false
  }),
  props: {
    activity: Object,
    syncState: String,
    loading: Boolean,
    submitting: Boolean,
    enableContinuableCreate: Boolean,
    enableContinuableActivity: Boolean,
    enableActivityInfo: Boolean,
    isActivityContinuable: Boolean,
    disableCancel: Boolean,
    isLite: Boolean
  },
  computed: {
    isInternal() {
      return authorizationStore.getters.isInternal;
    },
    continuableCreateRight() {
      return (
        this.enableContinuableCreate && 
        this.activity && 
        this.activity.id === 'create' &&
        authorizationStore.getters.isInternal
      );
    },
    mutableIsActivityContinuable: {
      get() {
        return this.isActivityContinuable;
      },
      set(val) {
        this.$emit('update:isActivityContinuable', val);
        this.$emit('activity:continue', val);
      }
    }
  }
}
</script>

<style lang="scss">
.fts-form-footer {
  display: flex;
  align-items: center;
  background-color: inherit;
  .form-footer__l {
    display: flex;
    align-items: center;
    &:not(:last-child) {
      margin-right: 1rem;
    }
  }
  .form-footer__r {
    min-width: 0;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    > *:not(:last-child) {
      margin-right: 0.375rem;
    } 
  }
  .form-btn-standard {
    flex-shrink: 0;
  }
  .form-activity-continue {
    margin-left: 0.5rem
  }
}
</style>